import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import styled from "styled-components";
const AboutSidebarContent = ({
  content,

  handleCloseFaqsOffCanvas,
  lastPath,
}) => {
  const { t } = useTranslation("common");
  const { push, locale, pathname } = useRouter();

  return (
    <div className="cs-widget my-3">
      <h3 className="cs-widget-title">{t("header_about")}</h3>
      <StyledAccordion className="cs-widget my-3">
        <div className="cs-widget mb-5">
          <div className="widget widget-categories mb-5">
            <ul>
              {content?.map((cont, idx) => {
                const isLastPath =
                  lastPath === cont?.path?.name && pathname.includes("[slug]");

                return (
                  <li
                    className="d-flex"
                    onClick={handleCloseFaqsOffCanvas}
                    key={idx}
                  >
                    <i className="fe-book text-muted mt-2 mr-2"></i>
                    <div
                      role="button"
                      onClick={() => {
                        push(cont?.path?.path);
                      }}
                    >
                      <a
                        className={`cs-widget-link ${
                          isLastPath ? "active" : ""
                        }`}
                        style={{ width: "fit-content" }}
                      >
                        {cont?.content.title[locale] || t(cont?.path.name)}
                      </a>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </StyledAccordion>
    </div>
  );
};

export default AboutSidebarContent;
const StyledAccordion = styled.div`
  .collapse {
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0, 1, 0, 1);
    display: block;
    pointer-events: none;
    padding: 0 !important;
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
  .collapse.show {
    height: auto;
    max-height: 9999px;
    pointer-events: all;
    transition: all 0.5s cubic-bezier(1, 0, 1, 0);
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
`;
